<template>
  <bk-page class="deleteAccountPage" pageType="navPage" :navBarInfo="navBarInfo" @close="close">

    <bkSuccessfully 
      v-if="showSuccessfully" 
      showConfirm
      :fixed="false" 
      langCode_description="userInfo_deleteAccount_msg_deleteSuccessfully" 
      @confirm="close()"
    />

		<bk-view v-else class="view-box" :loading="loading">
      <bk-view class="view-title">
        <bk-lang code="userInfo_deleteAccount_accountInformation"></bk-lang>
      </bk-view>
      <bk-view class="view-list">
        <bk-view class="view-item">
          <bk-input
            size="full"
            showFocusStatus
            autoComplete="off"
            v-model:value="formData.username"
            langCode_placeholder="userInfo_deleteAccount_emailPhonenumber">
          </bk-input>
        </bk-view>
        <bk-view class="view-item">
          <bk-input
            size="full"
            showFocusStatus
            input-type="password"
            autoComplete="new-password"
            v-model:value="formData.password"
            langCode_placeholder="login_text_password">
          </bk-input>
        </bk-view>
        <bk-view class="view-item">
          <bk-button class="view-delBtn" lang-code="global_button_delete" :loading="loadView==='save'" @click="handleSave"></bk-button>
        </bk-view>
        <bk-view class="view-item">
          <bk-button type="line" lang-code="global_confirm_cancelButton" @click="close"></bk-button>
        </bk-view>

				<bk-view class="view-footerText" v-if="showFooterText">{{ showFooterText }}</bk-view>


      </bk-view>

		</bk-view>
</bk-page>
</template>

<script>
	import bkSuccessfully from '@/components/bk-business/bk-successfully/bk-successfully.vue';
	import { authReq } from '@/reqService';

	export default {
		name: 'deleteAccount',
		components:{ bkSuccessfully },
		data (){
			return {
				loading: false,
				formData:{},
				userInfo:this.$bk_getUserInfo(),
				showSuccessfully:false,
			};
		},
		computed:{
			showFooterText (){
				let obj = {
					'clients.mase.cloud':'MaSe book appointment',
					'kis-book.mase.cloud':'KlS book appointment'
				};
				return obj[location.hostname];
			},
			navBarInfo (){
			
				return {
					langCode_title: this.showSuccessfully ? null : 'userInfo_deleteAccount_title',
					backFlag: this.$route.path.indexOf('deleteAccount') == -1
				};
			},
			langCode_btn (){
				let langCode_title = {
					deleteUser:'global_confirm_confirmButton'
				}[this.showScene]; 
				
				return 	langCode_title || 'userInfo_personal_save';
			},
			formConfig (){
				return {
					required:true,
					items:[
						{e:'input', type:'password', langCode:'userInfo_changePassword_password', key:'password' },
						{e:'input', type:'password', langCode:'userInfo_changePassword_confirmPassword', key:'newPassword' },
		
					]
				};
			}
		},
		methods:{
			close (){
				if(this.showSuccessfully){
					window.reloadPath = '/userInfo';
					this.$router.replace('/index');
					return false;
				}
				this.$emit('close');
			},
			initData (){
				if(this.$bk_isNull(this.userInfo?.id)){
					window.showLogin();
				}
			},
			// 提交
			async handleSave (){
				const { password, username } = this.formData;

				if (this.$bk_isNull(username)) {
					this.$bk_message.error({langCode: 'login_errMsg_username'});
					return;
				}

				if (this.$bk_isNull(password)) {
					this.$bk_message.error({langCode: 'login_errMsg_password'});
					return;
				}

				this.$bk_confirm({
					langCode_message: 'userInfo_tip_deleteUser',
				}).then(() => {
					this.deleteUser();
				});
			},
			async deleteUser (){
				const { password, username } = this.formData;

				await authReq.requestPostDeleteUserVerifyPassword(this, { 
					password, username
				});

				this.showSuccessfully = true;
				this.$bk_setUserInfo(undefined);
				this.$bk_setAccessToken(undefined);
			}
		}
		
	};
</script>

<style lang="less">
@import './deleteAccount.less';
</style>